import { CREHANA_HOSTNAME_PRD } from '@crehana/constants';

export const BACK_TO_SCHOOL = [
  {
    paragraph:
      'Guatemala: desde el 27 de Diciembre de 2021 hasta el 31 de Marzo de 2022',
  },
  {
    paragraph:
      'El Salvador: desde el 27 de Diciembre de 2021 hasta el 31 de Marzo de 2022',
  },
  {
    paragraph:
      'Honduras. desde el 27 de Diciembre de 2021 hasta el 31 de Marzo de 2022',
  },
  {
    paragraph:
      'Nicaragua: desde el 27 de Diciembre de 2021 hasta el 31 de Marzo de 2022',
  },
  {
    paragraph:
      'Costa Rica: desde el 27 de Diciembre de 2021 hasta el 31 de Marzo de 2022',
  },
  { paragraph: 'Panamá: desde el 15 de Febrero hasta el 31 de Mayo de 2022' },
  { paragraph: 'Ecuador: desde el 1° de Abril hasta el 30 de Junio de 2022' },
];

export const TERMS = [
  {
    paragraph:
      'Se otorgarán 20.000 cupones para redimir un pack de diez (10) cursos Crehana con vigencia de 12 meses a toda persona física o natural interesada en aplicar al beneficio',
  },
  {
    paragraph:
      'El pack de (10 cursos) se entrega como un beneficio agregado que no tiene costo ni valor, para las primeras 20.000 personas que cumplan con los procesos previos en la solicitud, cuenten con los requisitos y suministros de documentos requeridos por HP. Al finalizar exitosamente este proceso, la persona recibirá el beneficio que consiste en disfrutar de 12 meses gratis de acceso a 10 cursos que se encuentran en la plataforma de Crehana y hayan sido elegidos previamente por el cliente.',
  },
  {
    paragraph: `Una vez la persona finalice la compra en HP, recibirá el acceso al landing <a href="/hp" target="_blank" rel="noreferrer">${CREHANA_HOSTNAME_PRD}/hp</a>. Para activarlo debe ingresar al landing <a href="/hp" target="_blank" rel="noreferrer">${CREHANA_HOSTNAME_PRD}/hp</a>, ingresar el código individual y registrarse en Crehana. La persona deberá revisar y aceptar los Términos, Condiciones y Políticas que aparecen en <a href="/legal/terminos-y-condiciones/" target="_blank" rel="noreferrer">${CREHANA_HOSTNAME_PRD}/terminos </a>`,
    shouldParser: true,
  },
  {
    paragraph:
      'Una vez que la persona se encuentre activa, el código para acceder a la plataforma,  tendrá (30) días calendario de vigencia, contados desde el momento de su redención para disfrutar del acceso ilimitado a los cursos.',
  },
  {
    paragraph:
      'El beneficio puede ser activado entre el 25 de diciembre del 2021 y el 30 de abril del 2022 y está dirigido exclusivamente a:',
  },
  {
    paragraph: `Crehana se reserva el derecho de rescindir o suspender el acceso al servicio en cualquier momento, si la persona no cumple con las disposiciones establecidas en el presente documento y en los Términos y Condiciones generales del proveedor, que podrá revisar en <a href="/legal/terminos-y-condiciones/" target="_blank" rel="noreferrer">${CREHANA_HOSTNAME_PRD}/terminos</a>`,
    shouldParser: true,
  },
  {
    paragraph:
      'Este beneficio no es acumulable con otras promociones o beneficios en Crehana.',
  },
  {
    paragraph:
      'Válido solo para usuarios/persona que durante la vigencia de la campaña no tengan Membresía activa con Crehana y/o sean usuarios de Crehana Premium. ',
  },
  {
    paragraph:
      'En caso de que la convocatoria no sea cubierta, Crehana o HP no están obligadas a volver a realizar esta campaña.',
  },
  {
    paragraph:
      'En caso de que la persona o Usuario no accedan al beneficio, Crehana y/o  HP no están obligadas a buscar sustitutos y/o reemplazos o extender el plazo establecido para disfrutar el beneficio.',
  },
  {
    paragraph:
      'Crehana se reserva el derecho de mantener confidencialmente y sin divulgación abierta los datos de las personas beneficiadas con la campaña. ',
  },
  {
    paragraph:
      'El plazo máximo para canjear el beneficio es de 30 días calendario, una vez se envía el código al usuario.',
  },
  {
    paragraph: `Bajo ninguna circunstancia, el beneficio podrá ser canjeado por su equivalente en dinero u otros cursos y/o programas de <a href="/" target="_blank" rel="noreferrer">${CREHANA_HOSTNAME_PRD}</a>`,
    shouldParser: true,
  },
  {
    paragraph: 'Este beneficio es personal e intransferible.',
  },
  {
    paragraph:
      'La campaña es válida hasta completar los 20.000 cupos o hasta la vigencia de la campaña Back to School de cada país, lo que primero ocurra. Las personas que accedan a créditos educativos después de esta fecha o después de cumplir los cupos, no podrán acceder al beneficio.',
  },
];

export const REQUIREMENTS = [
  {
    paragraph: `Tener los recursos tecnológicos y de conectividad para poder hacer uso de la plataforma <a href="/" target="_blank" rel="noreferrer">${CREHANA_HOSTNAME_PRD}</a>.`,
    shouldParser: true,
  },
  {
    paragraph: `Registrarse en la plataforma de <a href="/" target="_blank" rel="noreferrer"> ${CREHANA_HOSTNAME_PRD}</a>.`,
    shouldParser: true,
  },
  {
    paragraph: `Ingresar a la landing <a href="/hp/" target="_blank" rel="noreferrer">${CREHANA_HOSTNAME_PRD}/hp</a> y seguir los pasos para redención.`,
    shouldParser: true,
  },
  {
    paragraph: `Revisar y aceptar los Términos, Condiciones y Políticas que aparecen en <a href="/legal/terminos-y-condiciones/" target="_blank" rel="noreferrer">${CREHANA_HOSTNAME_PRD}/terminos</a>. Se entiende tácitamente aceptados al permanecer en el sitio web.`,
    shouldParser: true,
  },
];

export const PERSONAL_DATA = [
  {
    paragraph:
      'El tratamiento de datos personales se realiza de acuerdo a la normativa vigente y el usuario autoriza a Crehana directamente para utilizar sus datos directamente en la activación de la Membresía.',
  },
  {
    paragraph: `Crehana es el único y exclusivo responsable de realizar la entrega del beneficio. Si tienes alguna pregunta relacionada al beneficio escribe a hola@crehana.com. No olvides visitar los Términos y Condiciones aplicables a todo el contenido de Crehana a través de <a href="/legal/terminos-y-condiciones/" target="_blank" rel="noreferrer">${CREHANA_HOSTNAME_PRD}/legal/terminos-y-condiciones/</a>`,
    shouldParser: true,
  },
  {
    paragraph:
      'Si eliges completar tus datos personales al registrarse, los mismos se compartirán con HP. Para obtener más información sobre cómo HP Inc. manejará sus datos personales, consulte la Declaración de privacidad de HP aquí: <a href="https://www.hp.com/lamerica_nsc_cnt_amer-es/privacy/privacy-central.html" target="_blank" rel="noreferrer"> https://www.hp.com/lamerica_nsc_cnt_amer-es/privacy/privacy-central.html </a>',
    shouldParser: true,
  },
];
